<template>
<transition name="fade">
  <div id="show-jobs">
    <h2>{{ msg }}</h2>
    <article class="paper">
      <p>Welcome to BioMall Online Portal.</p>
      <p>This is the web frontend for our API server available at <a href="https://bmll.cs.uno.edu/api"> bmll.cs.uno.edu/api</a>.</p>
      <p>You can run one of our programs and get the output through this portal.</p>
      <p>To get started click "Add Job"</p>
    </article>
    <h2>How to send a job?</h2>
    <article class="paper">
      <div class="aside"><img src="../assets/example.gif"></div>
      <p>Sending a job requires that you specify the software that you wish to run, the job title, and the input.</p>
      <p>To test the program, you may click the example button to add example input.</p>
      <p>You can also make your input and output private at 'View Jobs' by specifying a passkey.</p>
    </article>
    <h2>I am an Admin. How do I change things?</h2>
    <article class="paper">
      <p>If you are the admin to this portal and need assistance with setting up, running the application, or adding new software to the portal, please refer to the <a href="/guide/">Developer's Guide</a>. Note that you need admin password to continue.</p>
    </article>
  </div>
</transition>
</template>
<script>
export default {
	name: 'selectProgram',
	data () {
		return {
			msg: 'About this portal'
		}
	}
}
</script>
<style scoped>
h2 {
  margin-top: 1em;
}
</style>
